// removed by extract-text-webpack-plugin
module.exports = {"container":"MaxInactiveDays-container","inputField":"MaxInactiveDays-inputField","error":"MaxInactiveDays-error","isBusy":"MaxInactiveDays-isBusy"};